import { Site } from '@envato/foundation-types'
import * as Cookies from 'js-cookie'
import random from 'lodash-es/random'
import { ThunkAction } from 'redux-thunk'

import experimentsIds from '../../common/constants/experiments'
import { IRootState } from '../../common/reducers'
import { hasFeature } from '../../common/utils/features'
import { reportExperimentEnrolment } from '../analytics/experimentsAnalytics'

export enum TypeKeys {
  EXPERIMENT_DATA_RECEIVED = 'experimentDataReceived',
  EXPERIMENTS_READY = 'experimentsReady'
}

interface IExperimentData {
  running: string
  experiment_id: string
  variant?: string
}

interface IExperimentDataReceivedAction {
  type: TypeKeys.EXPERIMENT_DATA_RECEIVED
  payload: IExperimentData
}

interface IExperimentsReadyAction {
  type: TypeKeys.EXPERIMENTS_READY
  payload: boolean
}

export const experimentsReady = (): IExperimentsReadyAction => ({
  type: TypeKeys.EXPERIMENTS_READY,
  payload: true
})

export const getExperimentVariant = (
  experimentId: string
): IExperimentDataReceivedAction => {
  const experimentCookieKey = `experiment_${experimentId}`
  const experimentCookieValue = Cookies.get(experimentCookieKey)

  const experimentData: IExperimentData = {
    running: 'true',
    experiment_id: experimentId
  }

  // if the experiment cookie exist, simply fetch it from cookie
  if (experimentCookieValue) {
    experimentData.variant = experimentCookieValue

    // otherwise generate a random variant and save it to cookie
  } else {
    // pick a random number between (0, 3)  0,1 are variant A.  2,3 are variant B
    const randomVariant = random(3).toString()
    experimentData.variant = randomVariant

    // save it local cookie
    Cookies.set(experimentCookieKey, randomVariant, {
      expires: 90, // 90 days
      path: '/'
    })
  }

  try {
    reportExperimentEnrolment({
      experimentId,
      variant: experimentData.variant
    })
  } finally {
    /* tslint:disable:no-unsafe-finally */
    return {
      type: TypeKeys.EXPERIMENT_DATA_RECEIVED,
      payload: experimentData
    }
    /* tslint:enable:no-unsafe-finally */
  }
}

export const setExperiments = (): ThunkAction<
  IExperimentDataReceivedAction | IExperimentsReadyAction | null,
  IRootState,
  void
> => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common
    const { location } = getState().router
    const { experiments } = getState()

    const itemAttributesExperimentEnabled = hasFeature(
      'searchItemAttributes:enrolment',
      currentSite,
      location,
      experiments
    )

    const fileTypesExperimentEnabled = hasFeature(
      'fileTypesOnItemCard:enrolment',
      currentSite,
      location,
      experiments
    )

    if (fileTypesExperimentEnabled) {
      dispatch(
        getExperimentVariant(experimentsIds.graphicriverFileTypesOnItemCard)
      )
    }

    if (itemAttributesExperimentEnabled) {
      dispatch(getExperimentVariant(experimentsIds.codecanyonItemAttributes))
    }

    return dispatch(experimentsReady())
  }
}
